module.exports = __webpack_public_path__ + "img/jian04.04031363.png";